import PageTitle from '@/components/PageTitle';
import TelegramGroupCard from '@/components/TelegramGroupCard';
import ThemeWrapper from '@/components/ThemeWrapper';
import useThemeColors from '@/hooks/useThemeColors';
import AppLayout from '@/layouts/AppLayout';
import { Send } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TelegramGroup {
    id: number;
    title: string;
    telegram_group_url: string | null;
}

interface Props {
    telegram_groups: TelegramGroup[];
}

const ChannelsGroupsContent: React.FC<Props> = ({ telegram_groups }) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    return (
        <AppLayout>
            <PageTitle title="Canales y Grupos" />
            <div className="mx-auto max-w-7xl space-y-8">
                {/* Page Header */}
                <div className="space-y-4">
                    <h1 className="text-4xl font-bold text-gray-900 dark:text-white sm:text-5xl">
                        {t('channelsGroups.title')}
                    </h1>
                    <div className="space-y-2">
                        <p className="text-lg text-gray-700 dark:text-neutral-300 sm:text-xl">
                            {t('channelsGroups.description')}
                        </p>
                        <p className="text-base font-medium text-gray-600 dark:text-neutral-400 sm:text-lg">
                            {t('channelsGroups.reminder')}
                        </p>
                    </div>
                </div>

                {/* Telegram Groups Grid */}
                {telegram_groups.length === 0 ? (
                    <div className="rounded-lg border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-8 shadow-sm">
                        <div className="py-12 text-center">
                            <Send className="mx-auto mb-4 h-12 w-12 text-gray-400 dark:text-neutral-500" />
                            <h3 className="mb-2 text-2xl font-semibold text-gray-900 dark:text-white">
                                {t('channelsGroups.noGroupsTitle')}
                            </h3>
                            <p className="text-lg text-gray-600 dark:text-neutral-400">
                                {t('channelsGroups.noGroupsDescription')}
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {telegram_groups.map((group) => (
                            <TelegramGroupCard key={group.id} group={group} />
                        ))}
                    </div>
                )}
            </div>
        </AppLayout>
    );
};

const ChannelsGroups: React.FC<Props> = ({ telegram_groups }) => (
    <ThemeWrapper>
        <ChannelsGroupsContent telegram_groups={telegram_groups} />
    </ThemeWrapper>
);

export default ChannelsGroups;
